import * as types from '../mutation-types'
import {getAllCategory} from '@/api/categories' 

export const getDefaultState = ()=>{
    return {
        load: false,
        category: [],
    }
}
export const state = {
    category: [],
}
export const getters = {
    load : state => state.load,
    category : state => state.category
}
export const mutations = {
    [types.FETCH_CATEGORY_SUCCESS](state,payload){
        state.load = false;
        state.category = payload
    },
    [types.FETCH_CATEGORY_ERROR](state,payload){
        state.load = true;
        state.category = []
    },
}
export const actions = {
    async fetchCategory({commit},payload){
        commit(types.FETCH_CATEGORY_SUCCESS)
        try {
            const response = await getAllCategory(payload);
            commit(types.FETCH_CATEGORY_SUCCESS,response.items)
        } catch (error) {
            let error_ = error.response;
            commit(types.FETCH_CATEGORY_ERROR,error_);
        }
    },

}